<template>
  <div class="container">
    <div class="row align-items-start">
      <div class="col-md-3 col-sm-12 border rounded mb-4">
        <div class="row p-1 my-2">
          <label class="col pr-0">font family</label>
          <div class="col btn-group">
            <button
              class="btn btn-sm btn-light dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-expanded="false"
            >{{ selectedFontFamily }}</button>
            <!-- change this to font families -->
            <ul class="dropdown-menu">
              <li v-for="(font, index) in fontFamilies" :key="index">
                <a href="#" class="dropdown-item" @click="selectedFontFamily=font">{{ font }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row p-1 my-2">
          <div class="col pr-0 lh-2">
            <label>font size</label>
          </div>
          <div class="col-5 pr-0 pt-1">
            <input
              type="range"
              class="form-range"
              id="font-size-range"
              :min="minFontSize"
              :max="maxFontSize"
              v-model="selectedFontSize"
              step="2"
            />
          </div>
          <div class="col lh-2 pl-0">
            <label class="float-right">{{ selectedFontSize }}px</label>
          </div>
        </div>
        <div class="row p-1 my-2">
          <div class="col">
            <label>background color</label>
            <input
              type="color"
              class="btn btn-sm float-right"
              style="width: 40px; height: 25px; border: 1px solid #ccc;"
              :value="currentBgColor"
              title="Choose your color"
              @input="changeBgColor"
            />
          </div>
        </div>
        <div class="row p-1 my-2">
          <div class="col">
            <label>font color</label>
            <input
              type="color"
              class="btn btn-sm float-right"
              style="width: 40px; height: 25px; border: 1px solid #ccc;"
              :value="currentFontColor"
              title="Choose your color"
              @input="changeFontColor"
            />
          </div>
        </div>
        <div class="row p-1 my-2">
          <div class="col">
            <button type="button" class="btn btn-block btn-primary" @click="draw">Download image</button>
          </div>
        </div>
      </div>
      <div class="col px-sm-3 p-0">
        <textarea
          class="input form-control"
          dir="rtl"
          v-model="text"
          placeholder="enter your text in urdu here"
          rows="10"
        />
      </div>
    </div>
    <div class="row" v-show="text.length > 0">
      <div class="col">
        <div id="container" ref="canvasContainer" class="my-3 float-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Konva from "konva";

export default {
  name: "TextToImage",
  data() {
    return {
      minFontSize: 18,
      maxFontSize: 38,
      fontFamilies: ["Nafees Web", "Mehr Nastaliq Web"],
      selectedFontSize: 18,
      selectedFontFamily: "Mehr Nastaliq Web",
      text: "",
      stage: null,
      textLayer: null,
      konvaText: null,
      textAlign: "right",
      containerWidth: 0,
      containerHeight: 750,
      backgroundRect: null,
      currentBgColor: "#edd1b0",
      currentFontColor: "black",
    };
  },
  mounted() {
    this.containerWidth = this.$refs.canvasContainer.clientWidth;
    this.backgroundRect = new Konva.Rect({
      x: 0,
      y: 0,
      fill: this.currentBgColor,
    });

    this.stage = new Konva.Stage({
      container: "container",
    });
    this.textLayer = new Konva.Layer();
    this.konvaText = new Konva.Text({
      x: 0,
      y: 0,
      text: this.text,
      padding: 20,
      fill: this.currentFontColor,
      lineHeight: 1.65,
      fontSize: this.selectedFontSize,
      fontFamily: this.selectedFontFamily,
      align: this.textAlign,
    });
    this.textLayer.add(this.backgroundRect);
    this.textLayer.add(this.konvaText);
    this.stage.add(this.textLayer);
  },
  watch: {
    text(value) {
      this.konvaText.text(value);
      this.stage.height(this.konvaText.height());
      this.stage.width(this.konvaText.width());
      this.backgroundRect.height(this.konvaText.height());
      this.backgroundRect.width(this.konvaText.width());
      this.stage.draw();
      this.textLayer.draw();
    },
    selectedFontSize(value) {
      this.konvaText.fontSize(parseInt(value));
      this.stage.height(this.konvaText.height());
      this.stage.width(this.konvaText.width());
      this.backgroundRect.height(this.konvaText.height());
      this.backgroundRect.width(this.konvaText.width());
      this.stage.draw();
      this.textLayer.draw();
    },
    selectedFontFamily(value) {
      this.konvaText.fontFamily(value);
      this.stage.height(this.konvaText.height());
      this.stage.width(this.konvaText.width());
      this.backgroundRect.height(this.konvaText.height());
      this.backgroundRect.width(this.konvaText.width());
      this.stage.draw();
      this.textLayer.draw();
    },
  },
  methods: {
    draw() {
      const dataURL = this.stage.toDataURL({ pixelRatio: 3 });
      this.downloadURI(dataURL, "text.png");
    },
    fontSize(num) {
      return `${num}px`;
    },
    downloadURI(uri, name) {
      const link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    changeBgColor(ev) {
      this.currentBgColor = ev.target.value;
      this.backgroundRect.fill(ev.target.value);
      this.stage.draw();
    },
    changeFontColor(ev) {
      this.currentFontColor = ev.target.value;
      this.konvaText.fill(ev.target.value);
      this.stage.draw();
    },
  },
};
</script>